import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b79a23aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "content item-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Версия 2.0.0", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "Долгожданная версия 2.0.0 бота UFO вышла! В этом обновлении бот был был полностью переписан на язык TypeScript. Вместе с этим бот был переделан под новые возможности дискорда, было добавлено большое количество новых функций, переработаны старые, а также исправлено множество багов.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Основное", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "1. Новый логотип и аватарка бота.", -1))
const _hoisted_7 = { class: "paragraph" }
const _hoisted_8 = { class: "paragraph" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"subtitle\" data-v-b79a23aa>Веб сайт</div><div class=\"paragraph\" data-v-b79a23aa>1. Сайт также был переписан на язык TypeScript и фреймворк Vue 3.</div><div class=\"paragraph\" data-v-b79a23aa>2. Обновлена цветовая палитра сайта.</div><div class=\"paragraph\" data-v-b79a23aa>3. Пофикшен баг, при котором в некоторых браузерах некоторые компоненты сайта не отображались по центру.</div><div class=\"paragraph\" data-v-b79a23aa>4. Теперь язык сайта изменяется без перезагрузки страницы.</div>", 5)
const _hoisted_14 = { class: "paragraph" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "6. Теперь все настройки серверов кешируются. Если вы зашли в настройки сервера, они загружаются только один раз, после чего Вы можете перемещаться между страницами, и настройки этого сервера загружаться больше не будут. Если Вы измените и сохраните настройки, они так же обновятся у Вас в кеше. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "7. Теперь настройки команд будут также обновлять переопределения прав для слеш-команд. Для этого вам придется заново авторизоваться на сайте чтобы предоставить приложению возможность обновлять права слеш-команд. ", -1))
const _hoisted_17 = { class: "paragraph" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "9. Из настроек сервера удалена вкладка Буст. Теперь все донатные функции настраиваются в тех категориях настроек, к которым они относятся. Например, денежные бонусы настраиваются во вкладке Экономика. ", -1))
const _hoisted_19 = { class: "paragraph" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"subtitle\" data-v-b79a23aa>Экономика</div><div class=\"paragraph\" data-v-b79a23aa>1. Команды для управления балансом участника <code data-v-b79a23aa>добавить-деньги</code>, <code data-v-b79a23aa>забрать-деньги</code> и <code data-v-b79a23aa>установить-баланс</code> были заменены одной командой <code data-v-b79a23aa>баланс-менеджер &lt;участник&gt; &lt;добавить | забрать | установить&gt; &lt;количество&gt;</code>.</div><div class=\"paragraph\" data-v-b79a23aa>2. Минимальные ставки теперь устанавливаются для всех игр сразу.</div><div class=\"paragraph\" data-v-b79a23aa>3. Донатная функция &quot;Деньги за сообщения&quot; удалена, вместо нее добавлен &quot;Опыт за сообщения&quot;. Вы можете настроить случайное количество опыта, которое будет выдаваться с указанной вероятностью участникам при отправке сообщений.</div>", 4)
const _hoisted_24 = { class: "paragraph" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"paragraph\" data-v-b79a23aa>5. Магазин</div><div class=\"subparagraph\" data-v-b79a23aa>5.1. Теперь в товаре можно установить необходимый для его покупки опыт. При этом опыт списываться не будет, но если у участника будет меньше опыта, купить товар он не сможет.</div><div class=\"subparagraph\" data-v-b79a23aa>5.2. Теперь выдаваемое количество опыта при покупке товара можно сделать случайным, установив минимальное и максимальное значение. Если Вы хотите установить фиксированное значение, введите его в поле для минимального и максимального значения.</div><div class=\"subparagraph\" data-v-b79a23aa>5.3. Теперь можно установить необходимые роли для покупки товара. Если у участника не будет хотя-бы одной из этих ролей, купить товар он не сможет.</div><div class=\"subparagraph\" data-v-b79a23aa>5.4. В качестве донатной функции добавлена возможность установить иконку товара (необходимо указать URL картинки в настройках товара). Она будет отображаться в качестве маленькой картинки эмбеда в информации о товаре или при его покупке.</div><div class=\"paragraph\" data-v-b79a23aa>6. Пользовательские работы</div><div class=\"subparagraph\" data-v-b79a23aa>6.1. Добавлены пользовательские работы. Теперь вместо обычной работы Вы можете установить на своем сервере список из нескольких работ со своими параметрами.</div><div class=\"subparagraph\" data-v-b79a23aa>6.2. Добавлять, изменять и удалять пользовательские работы можно на сайте. Они имеют следующие параметры: название, описание, сообщение по окончании работы, зарплата (минимум и максимум), кулдаун, необходимый опыт и необходимые роли</div><div class=\"subparagraph\" data-v-b79a23aa>6.3. В пользовательских работах Вы можете устанавливать как положительные, так и отрицательные значения зарплаты</div><div class=\"subparagraph\" data-v-b79a23aa>6.4. Сообщение по окончании работы представляет собой шаблон сообщения, который будет отображаться участникам, если они выберут эту работу. Оно имеет переменную <code data-v-b79a23aa>{{work}}</code>, которая содержит информацию о полученной зарплате и балансе участника. С помощью условий Вы можете установить разный текст в этом сообщении для разных значений зарплаты. Если сообщение не устанавливать, то будет отображаться сообщение по умолчанию, как в обычных работах. Подробнее про шаблоны сообщений Вы можете найти в <a class=\"primary-link\" href=\"https://docs.ufobot.ru/templates/usage\" target=\"_blank\" data-v-b79a23aa>Документации</a>. </div>", 10)
const _hoisted_35 = { class: "subparagraph" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "работать", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subparagraph" }, "6.6. В качестве донатной функции добавлена возможность установить иконку работы. Она будет отображаться в информации о работе и после работы как маленькая картинка в эмбеде. ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Игры", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "1. Как уже было сказано выше, в играх вместо реакций теперь используются взаимодействия Discord. ", -1))
const _hoisted_40 = { class: "paragraph" }
const _hoisted_41 = { class: "paragraph" }
const _hoisted_42 = { class: "paragraph" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paragraph" }, "5. Камень ножницы бумага", -1))
const _hoisted_44 = { class: "subparagraph" }
const _hoisted_45 = { class: "subparagraph" }
const _hoisted_46 = { class: "paragraph" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subparagraph" }, "6.1. Игра дуэль была полностью переработана и улучшена. Теперь у каждого игрока при старте 100 HP, каждый выстрел наносит случайное количество урона. Кроме этого добавлено снаряжение: шлем, бронежилет, прицел, аптечка и граната. При старте игроки могут выбрать 2 любых элемента снаряжения. ", -1))
const _hoisted_48 = { class: "subparagraph" }
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"subparagraph\" data-v-b79a23aa>6.3. Каждый выстрел может с определенной вероятностью попасть в ту или иную часть тела и нанести разное количество урона. </div><div class=\"subparagraph\" data-v-b79a23aa>6.4. Попадание в ногу происходит с вероятностью 40%, если у игрока нет прицела, и с вероятностью 15%, если у игрока есть прицел. Наносит от 1 до 15 единиц урона противнику. </div><div class=\"subparagraph\" data-v-b79a23aa>6.5. Попадание в тело происходит с вероятностью 55%, если у игрока нет прицела, и с вероятностью 75%, если у игрока есть прицел. Наносит от 10 до 40 единиц урона противнику, если у него нет бронежилета, и от 5 до 20 единиц урона, если у него есть бронежилет. </div><div class=\"subparagraph\" data-v-b79a23aa>6.6. Попадание в голову происходит с вероятностью 5%, если у игрока нет прицела, и с вероятностью 10%, если у игрока есть прицел. Наносит 100 единиц урона противнику и мгновенно убивает его, если у него нет шлема. Если у противника есть шлем, он получает 30 единиц урона, и его шлем разрушается (пропадает из его инвентаря). </div><div class=\"subparagraph\" data-v-b79a23aa>6.7. Вместо выстрела игрок может использовать аптечку, если она есть у него в инвентаре, нажав на кнопку &quot;Аптечка&quot;. Аптечка восстанавливает 50 HP, после чего пропадает из инвентаря. </div><div class=\"subparagraph\" data-v-b79a23aa>6.8. Вместо выстрела игрок может использовать гранату, если она есть у него в инвентаре, нажав на кнопку &quot;Граната&quot;. Граната наносит противнику от 20 до 60 единиц урона. </div><div class=\"subtitle\" data-v-b79a23aa>Приветствия</div><div class=\"paragraph\" data-v-b79a23aa>1. Полностью переработана система приветствий. Теперь они могут содержать не только текстовое сообщение, но и эмбед. </div><div class=\"paragraph\" data-v-b79a23aa>2. Как в текстовом сообщении, так и в эмбеде можно использовать переменные шаблона. Приветствия содержат переменные <code data-v-b79a23aa>{{member}}</code> и <code data-v-b79a23aa>{{guild}}</code>. Подробнее про шаблоны сообщений Вы можете найти в <a class=\"primary-link\" href=\"https://docs.ufobot.ru/templates/usage\" target=\"_blank\" data-v-b79a23aa>Документации</a>. </div><div class=\"paragraph\" data-v-b79a23aa>3. Ввод текстового сообщения осуществляется в новое поле для ввода шаблона, о котором уже было сказано выше. </div><div class=\"paragraph\" data-v-b79a23aa>4. Вместо текстового сообщения или вместе с ним Вы можете использовать эмбед. Включите переключатель, который расположен рядом с кнопкой Эмбед. Затем нажмите кнопку, чтобы открыть окно настройки эмбеда. В нём Вы можете настроить цвет, добавить автора, название, описание, поля, футер, отметку времени и установить различные картинки и иконки. Несмотря на то, что не все поля ввода содержат кнопку для вставки переменной, Вы можете использовать переменные шаблона абсолютно в каждом поле. Например, Вы можете установить аватар участника в качестве иконки автора, введя в поле &quot;Ссылка на иконку автора&quot; значение <code data-v-b79a23aa>{{member.avatarUrl}}</code>. </div><div class=\"paragraph\" data-v-b79a23aa>5. В качестве отметки времени Вы можете выбрать текущее время (время, в которое произошло событие), поставить определенную дату или выбрать переменную шаблона из списка. </div>", 12)
const _hoisted_61 = { class: "paragraph" }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"subtitle\" data-v-b79a23aa>Модерация</div><div class=\"paragraph\" data-v-b79a23aa>1. Теперь в случае мута, если его длительность меньше 28 дней, бот будет также отправлять участника в тайм-аут. По умолчанию это настройка включена, но ее можно выключить на сайте в настройках во вкладке Модерация. </div><div class=\"paragraph\" data-v-b79a23aa>2. Переработана донатная функция &quot;Сообщения в ЛС при наказании&quot;. Теперь эти сообщения также могут содержать не только текст, но и эмбед. Также были добавлены тесты, с помощью которых можно проверить правильность настройки сообщений, эмбедов и шаблонов. После запуска теста соответствующее сообщение будет отправлено Вам в ЛС. </div><div class=\"paragraph\" data-v-b79a23aa>3. Переработана автомодерация</div><div class=\"subparagraph\" data-v-b79a23aa>3.1. Теперь в настройках фильтра автомодерации на сайте можно включить не только выдачу наказания участнику, но и отправку сообщения. Это сообщение может быть, например, устным предупреждением участника о нарушении или упоминанием модераторской роли с целью сообщить о нарушении. Его также можно отправить в определенный канал. </div><div class=\"subparagraph\" data-v-b79a23aa>3.2. Добавлен новый фильтр автомодерации: Флуд. В параметрах он содержит две настройки: максимум сообщений в минуту и максимум символов в минуту. Если это количество сообщений или сумма символов в сообщениях будет превышена участником меньше, чем за минуту, бот отреагирует на это. </div><div class=\"subtitle\" data-v-b79a23aa>Донат</div><div class=\"paragraph\" data-v-b79a23aa>1. Как уже было сказано выше, функция &quot;Деньги за сообщения&quot; была заменена на &quot;Опыт за сообщения&quot;, а также добавлена возможность установить иконки для товаров и пользовательских работ. </div><div class=\"paragraph\" data-v-b79a23aa>2. Новые лимиты</div><div class=\"subparagraph\" data-v-b79a23aa>2.1. Лимит товаров в магазине: 30. Для серверов без UFO буста: 15.</div><div class=\"subparagraph\" data-v-b79a23aa>2.2. Лимит пользовательских работ: 15. Для серверов без UFO буста: 5.</div><div class=\"subparagraph\" data-v-b79a23aa>2.3. Лимит розыгрышей: 15. Для серверов без UFO буста: 5.</div><div class=\"subparagraph\" data-v-b79a23aa>2.4. Лимит купонов: 15. Для серверов без UFO буста: 5.</div><div class=\"paragraph\" data-v-b79a23aa>3. Новые цены: 59₽/месяц за стандарт и 99₽/месяц за премиум.</div><div class=\"subtitle\" data-v-b79a23aa>Удаление настроек</div><div class=\"paragraph\" data-v-b79a23aa>1. К сожалению, из-за переработки некоторых функций нам не удастся сохранить их предыдущие настройки, поэтому эти функции Вам нужно будет настроить заново. </div><div class=\"subparagraph\" data-v-b79a23aa>1.1. Удалены предыдущие настройки приветствий.</div><div class=\"subparagraph\" data-v-b79a23aa>1.2. Удалены предыдущие настройки сообщений в ЛС при наказании.</div><div class=\"subparagraph\" data-v-b79a23aa>1.3. Удалены предыдущие настройки автомодерации.</div><div class=\"subparagraph\" data-v-b79a23aa>1.4. Удалены предыдущие настройки работ и мешков.</div>", 20)

import ImageOverlay from "@/components/v2/ImageOverlay.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'V2Ru',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode("2. В бота добавлены "),
        _createVNode(ImageOverlay, {
          name: "Слеш-команды",
          file: "ru/slashes.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("слеш-команды")
          ]),
          _: 1
        }),
        _createTextVNode(". Их язык не зависит от языка команд сервера, он устанавливается в соответствии с языком Вашего клиента Discord: русский, если язык клиента русский, в остальных случаях английский. Текстовые команды в боте остаются. ")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode("3. Вместо реакций теперь используются "),
        _createVNode(ImageOverlay, {
          name: "Взаимодействия",
          file: "ru/interactions.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("взаимодействия")
          ]),
          _: 1
        }),
        _createTextVNode(" Discord (кнопки, списки, модальные окна и т. п.).")
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode("5. Новые "),
        _createVNode(ImageOverlay, {
          name: "Значки",
          file: "ru/badges.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("значки")
          ]),
          _: 1
        }),
        _createTextVNode(" пользователя на странице профиля. ")
      ]),
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createTextVNode("8. Добавлено новое "),
        _createVNode(ImageOverlay, {
          name: "Поле ввода шаблона",
          file: "ru/template.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("поле ввода")
          ]),
          _: 1
        }),
        _createTextVNode(" текста для шаблонов сообщений. Кроме текстового поля оно содержит кнопки вставки упоминания роли, канала, переменной, соответствующей этому шаблону и ссылку на документацию по шаблонам сообщений. ")
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createTextVNode("10. Добавлены "),
        _createVNode(_component_router_link, {
          class: "primary-link",
          to: "/terms"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Условия использования")
          ]),
          _: 1
        }),
        _createTextVNode(" и "),
        _createVNode(_component_router_link, {
          class: "primary-link",
          to: "/privacy"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Политика конфиденциальности")
          ]),
          _: 1
        }),
        _createTextVNode(". Ссылки на них расположены в футере. ")
      ]),
      _hoisted_20,
      _createElementVNode("div", _hoisted_24, [
        _createTextVNode("4. В команды "),
        _createVNode(ImageOverlay, {
          name: "Лидеры",
          file: "ru/leaders.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("лидеры")
          ]),
          _: 1
        }),
        _createTextVNode(" и "),
        _createVNode(ImageOverlay, {
          name: "Магазин",
          file: "ru/shop.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("магазин")
          ]),
          _: 1
        }),
        _createTextVNode(" добавлена возможность листать страницы с помощью кнопок-стрелочек. ")
      ]),
      _hoisted_25,
      _createElementVNode("div", _hoisted_35, [
        _createTextVNode("6.5. Если на сервере есть пользовательские работы, то при использовании команды "),
        _hoisted_36,
        _createTextVNode(" участник увидит "),
        _createVNode(ImageOverlay, {
          name: "Выбор работы",
          file: "ru/job-menu.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("список ")
          ]),
          _: 1
        }),
        _createTextVNode(" всех названий работ. Выбрав одну из работ, участник увидит все ее "),
        _createVNode(ImageOverlay, {
          name: "Параметры работы",
          file: "ru/job-select.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("параметры")
          ]),
          _: 1
        }),
        _createTextVNode(". Если участнику доступна работа (прошел кулдаун и имеются необходимые роли и опыт), он сможет нажать кнопку Работать. Ему начислится случайное значение зарплаты в диапазоне от минимального значения до максимального, и отобразится "),
        _createVNode(ImageOverlay, {
          name: "Конец работы",
          file: "ru/job-ending.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("сообщение")
          ]),
          _: 1
        }),
        _createTextVNode(" по окончании работы. ")
      ]),
      _hoisted_37,
      _hoisted_38,
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createTextVNode("2. В "),
        _createVNode(ImageOverlay, {
          name: "Краш казино",
          file: "ru/crash.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("краш-казино")
          ]),
          _: 1
        }),
        _createTextVNode(" поднимать множитель теперь можно кнопкой \"Поднять\". Чтобы остановиться и забрать деньги, нужно нажать кнопку \"Стоп\". В рамках ребаланса с каждым поднятием множитель теперь поднимается на 0.4, а вероятность проиграть равна 25%. ")
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createTextVNode("3. "),
        _createVNode(ImageOverlay, {
          name: "Минное поле",
          file: "ru/minefield.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Минное поле")
          ]),
          _: 1
        }),
        _createTextVNode(" содержит 3 кнопки-стрелки для выбора клетки и кнопку со значком \"стоп\" для остановки. В рамках ребаланса минное поле теперь имеет множители x1 и x2. ")
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createTextVNode("4. "),
        _createVNode(ImageOverlay, {
          name: "Джекпот",
          file: "ru/jackpot.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Джекпот")
          ]),
          _: 1
        }),
        _createTextVNode(" теперь содержит кнопку \"Ввести\", при нажатии на которую открывается "),
        _createVNode(ImageOverlay, {
          name: "Модальное окно",
          file: "ru/jackpot-modal.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("модальное окно")
          ]),
          _: 1
        }),
        _createTextVNode(", содержащее поле ввода. В него нужно ввести 7 чисел через пробел и нажать \"Отправить\". ")
      ]),
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _createTextVNode("5.1. Имеет "),
        _createVNode(ImageOverlay, {
          name: "Камень ножницы бумага",
          file: "ru/rsp.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("меню выбора")
          ]),
          _: 1
        }),
        _createTextVNode(", в котором можно выбрать камень, ножницы или бумагу. ")
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createTextVNode("5.2. Теперь можно играть в камень ножницы бумага с другим участником. Для этого после ставки нужно указать нужного участника. Он может "),
        _createVNode(ImageOverlay, {
          name: "Принятие игры",
          file: "ru/rsp-accept.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("принять или отклонить")
          ]),
          _: 1
        }),
        _createTextVNode(" игру с помощью кнопок. Затем каждый из участников сможет "),
        _createVNode(ImageOverlay, {
          name: "Выбор",
          file: "ru/rsp-player.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("выбрать")
          ]),
          _: 1
        }),
        _createTextVNode(" из списка камень, ножницы или бумагу. "),
        _createVNode(ImageOverlay, {
          name: "Победитель",
          file: "ru/rsp-winner.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Победителю")
          ]),
          _: 1
        }),
        _createTextVNode(" достанутся выигранные деньги. ")
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createTextVNode("6. "),
        _createVNode(ImageOverlay, {
          name: "Новые дуэли",
          file: "ru/duel.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Новые дуэли")
          ]),
          _: 1
        })
      ]),
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        _createTextVNode("6.2. При вводе команды нужно указать участника, с которым вы хотите играть, и он также сможет принять или отклонить игру с помощью кнопок. Затем каждый игрок по очереди должен выбрать до двух элементов "),
        _createVNode(ImageOverlay, {
          name: "Снаряжение",
          file: "ru/duel-equipment.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("снаряжения")
          ]),
          _: 1
        }),
        _createTextVNode(" из списка. Затем игроки по очереди наносят друг другу урон. Тот, у кого закончится HP, проиграет. ")
      ]),
      _hoisted_49,
      _createElementVNode("div", _hoisted_61, [
        _createTextVNode("6. В приветствия добавлены "),
        _createVNode(ImageOverlay, {
          name: "Тесты",
          file: "ru/greetings-tests.png"
        }, {
          default: _withCtx(() => [
            _createTextVNode("тесты")
          ]),
          _: 1
        }),
        _createTextVNode(". С их помощью Вы можете проверить правильность настройки сообщений, эмбедов и переменных шаблона. После запуска теста соответствующее сообщение будет отправлено в соответствующий канал или ЛС. ")
      ]),
      _hoisted_62
    ])
  ]))
}
}

})